import {Injectable} from '@angular/core';
import {ApibaseService} from './apibase.service';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {EntityIndicador} from '~entity/entity-indicador/entity-indicador.model';
import {ResultMessageVo} from '~model/vo/result-message-vo';

@Injectable({
  providedIn: 'root',
})
export class IndicadoresAPIService extends ApibaseService {
  prefixoUrl = 'controlTower';
  urlFunction = 'configuracao/indicador';

  getIndicadores(): Observable<{indicadores: {[key: string]: EntityIndicador}}> {
    return super.get<{indicadores: {[key: string]: EntityIndicador}}>().pipe(this.defaultCatch());
  }

  updateIndicador(indicador: EntityIndicador): Observable<EntityIndicador|ResultMessageVo> {
    return super.put('',  {extraUrl: indicador.id, objEnvio: indicador}).pipe(
      map(entity => entity as EntityIndicador),
      catchError((err) => {
        const erro = {erro: true, message: 'Ocorreu um erro inesperado na operação'};
        if (err.status === 404) {
          erro.message = 'Indicador não encontrado';
        }
        if (err.status === 400) {
          erro.message = 'Essa operação não foi permitida';
        }
        return of(erro);
      })
    );
  }

  updateIndicadorExibir(id: string, exibir: boolean, percentuais: boolean = false): Observable<EntityIndicador|ResultMessageVo> {
    let sufixUrl = 'exibir';

    if (!exibir) {
      sufixUrl = 'esconder';
    }

    if (percentuais) {
      sufixUrl = sufixUrl + '-percentual';
    }

    return super.put(id,  {sufixUrl}).pipe(
      map(entity => entity as EntityIndicador),
      catchError((err) => {
        const erro = {erro: true, message: 'Ocorreu um erro inesperado na operação'};
        if (err.status === 404) {
          erro.message = 'Indicador não encontrado';
        }
        if (err.status === 400) {
          erro.message = 'Essa operação não foi permitida';
        }
        return of(erro);
      })
    );
  }

  addIndicador(indicador: EntityIndicador): Observable<ResultMessageVo> {
    return super.post({objEnvio: indicador}).pipe(
      map(_ => ({message: 'Indicador criado com sucesso'})),
      catchError((err) => {
        const erro = {erro: true, message: 'Ocorreu um erro inesperado na operação'};
        if (err.status === 400) {
          erro.message = 'Essa operação não foi permitida';
        }
        return of(erro);
      })
    );
  }
}
